const functionRegistry = {};

// register a group of functions by a name
export const registerFunctions = (name, fnGroup) => {
  functionRegistry[name] = fnGroup;
};

// get a group of functions by a name
export const getFunctions = (name) => functionRegistry[name];
